import React, { useState, useEffect } from "react"
import Layout from "../components/Layout/Layout"
import Seo from "../components/Core/Seo"
import { Container } from "styled-bootstrap-grid"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"
import { withTranslation } from "gatsby-plugin-react-i18next"
import { isBrowser } from "../services/browser"
import { getIsFrance } from "../services/locale"
import ProductDetails from "../components/Pdp/ProductDetails"
import { replaceMaterialWord } from "../services/material"
import { getProductTags } from "../services/productHelper"
import PdpGlobalStyle from "../components/Core/PdpGlobalStyle"
import Collections from "../components/Pdp/Collections"

const ProductTemplate = (props) => {
  const [cookieSeen, setCookieSeen] = useState(false)

  useEffect(() => {
    if (isBrowser()) {
      let status = localStorage.getItem("policyState") === "shown"
      setCookieSeen(status)
    }
  }, [])

  const { location, data, pageContext } = props

  const isFrance = getIsFrance()

  const path = location.pathname
  const prevState = location.state

  const product = data.product
  const content = data.content
  const collections = data.collections.edges
  const alternatePath = pageContext.alternatePath
  const validUrls = pageContext.validUrls

  const material = pageContext.material

  const metaTitle = content.metaTitle
  const metaDescription = content.metaDescription

  const pageTitle = content.pageTitle

  const isWedding = product.productType.toLowerCase() === "wedding band"

  const descriptionFr =
    product.metafields.length > 0 &&
    product.metafields.find((field) => field.key.trim() === "description_fr")
  const description = !isFrance
    ? product.descriptionHtml
    : descriptionFr?.value || product.descriptionHtml
  const titleFr =
    product.metafields.length > 0 &&
    product.metafields.find((field) => field.key.trim() === "title_fr")
  const title = !isFrance ? product.title : titleFr?.value || product.title

  let discontinued = false
  let hidePromoBanner = false
  let archive = false
  let comingSoon = false
  let letterEdit = false

  const productTags = getProductTags(product, content)

  if (productTags) {
    productTags.forEach((tag) => {
      if (tag === "discontinued") {
        discontinued = true
      }

      if (tag === "winter-archives") {
        archive = true
      }

      // Alex Eagle - temporary

      if (tag === "alex-eagle") {
        hidePromoBanner = true
      }

      if (tag === "coming-soon") {
        comingSoon = true
      }

      if (tag === "letter-edit") {
        letterEdit = true
      }
    })
  }

  return (
    <Layout
      prefooter={true}
      discontinued={discontinued}
      alternatePath={validUrls.length > 0 ? validUrls : alternatePath}
      isPromoBannerDisabled={hidePromoBanner}
      pdp={1}
      archive={archive ? 1 : 0}
    >
      <Seo
        title={
          material
            ? replaceMaterialWord(metaTitle ? metaTitle : title, material.color)
            : metaTitle
              ? metaTitle
              : title
        }
        description={
          material
            ? replaceMaterialWord(
                metaDescription ? metaDescription : description,
                material?.color
              )
            : metaDescription
              ? metaDescription
              : description
        }
        fullTitle={true}
        path={path}
        alternatePath={alternatePath}
        isPromoBannerDisabled={hidePromoBanner}
        validUrls={validUrls}
      />
      <PdpGlobalStyle />
      <Helmet
        bodyAttributes={{ class: `product-page ${cookieSeen && "seen"}` }}
      />
      <Container>
        <ProductDetails
          product={product}
          content={content}
          title={pageTitle ? pageTitle : title}
          description={description}
          h1={content.subtitle}
          material={material}
          wedding={isWedding}
          collections={collections}
          prevState={prevState}
          comingSoon={comingSoon}
          letterEdit={letterEdit}
        />
        <Collections />
      </Container>
    </Layout>
  )
}

export default withTranslation()(ProductTemplate)

export const pageQuery = graphql`
  query ProductQuery(
    $language: String!
    $handle: String!
    $contentBlockId: String!
    $locale: String!
  ) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    collections: allContentfulCollectionContent(
      filter: { node_locale: { eq: $locale } }
    ) {
      edges {
        node {
          id
          handle
          urlKey
          title
        }
      }
    }
    product: shopifyProduct(handle: { eq: $handle }) {
      id
      shopifyId
      handle
      title
      descriptionHtml
      description
      totalInventory
      productType
      metafields {
        key
        value
      }
      variants {
        id
        price
        shopifyId
        media {
          id
          # ...VariantImageFragment
          ... on ShopifyMediaImage {
            image {
              gatsbyImageData(width: 860)
              portrait: gatsbyImageData(width: 1332, aspectRatio: 0.82835820895)
              originalSrc
              altText
              width
              height
            }
          }
        }
        title
        availableForSale
        position
        selectedOptions {
          name
          value
        }
      }
      options {
        # shopifyId
        values
        name
      }
      priceRangeV2 {
        minVariantPrice {
          amount
          currencyCode
        }
      }
      tags
      media {
        id
        ... on ShopifyMediaImage {
          image {
            src
            originalSrc
            width
            height
            gatsbyImageData(width: 2000, height: 2000)
            altText
          }
        }
      }
      createdAt
    }
    content: contentfulProductContent(
      contentful_id: { eq: $contentBlockId }
      node_locale: { eq: $locale }
    ) {
      pageTitle
      metaTitle
      subtitle
      metaDescription
      numberOfDiamonds
      shapeOfDiamonds
      diamondColor
      diamondClarity
      carats
      goldWeight
      necklaceLengths
      sizeFit
      urlKey
      referredProductUrlKey
      inAntwerp
      sizeAndFit {
        raw
      }
      labGrownDiamondsText {
        raw
      }
      recycledGoldText {
        raw
      }
      noReturnsResizable
      tags
    }
  }
`
